// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-select-leng-container {
    position: relative;
  }
  
  .mobile-selected-lang-option {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: bold;
    padding: 10px 15px;
    border-radius: 4px;
    justify-content: space-between;
  }
  
  .mobile-flag-icon {
    width: 24px;
    height: 16px;
    margin-right: 10px;
  }
  
  .mobile-flag-arrow {
    margin-left: auto;
    transition: transform 0.3s;
  }
  
  .mobile-flag-arrow.rotate {
    transform: rotate(180deg);
  }
  
  .mobile-select-with-flags {
    display: flex;
    flex-direction: column;
    /* width: 100%; */
    position: absolute;
    top: 50px;
    left: 0;
    background-color: white;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    z-index: 1000;
  }
  
  .mobile-flag-option {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    cursor: pointer;
  }
  
  .mobile-flag-option:hover {
    background-color: #f1f1f1;
  }
  
  .mobile-flag-option.selected {
    font-weight: bold;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/mobileSelectFlags/styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,uBAAuB;IACvB,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":[".mobile-select-leng-container {\n    position: relative;\n  }\n  \n  .mobile-selected-lang-option {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    font-weight: bold;\n    padding: 10px 15px;\n    border-radius: 4px;\n    justify-content: space-between;\n  }\n  \n  .mobile-flag-icon {\n    width: 24px;\n    height: 16px;\n    margin-right: 10px;\n  }\n  \n  .mobile-flag-arrow {\n    margin-left: auto;\n    transition: transform 0.3s;\n  }\n  \n  .mobile-flag-arrow.rotate {\n    transform: rotate(180deg);\n  }\n  \n  .mobile-select-with-flags {\n    display: flex;\n    flex-direction: column;\n    /* width: 100%; */\n    position: absolute;\n    top: 50px;\n    left: 0;\n    background-color: white;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n    z-index: 1000;\n  }\n  \n  .mobile-flag-option {\n    display: flex;\n    align-items: center;\n    padding: 10px 15px;\n    cursor: pointer;\n  }\n  \n  .mobile-flag-option:hover {\n    background-color: #f1f1f1;\n  }\n  \n  .mobile-flag-option.selected {\n    font-weight: bold;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
